import React, {useContext} from 'react';
import {FaArrowLeft, FaArrowRight} from 'react-icons/fa';
import {ThemeContext} from "../../../ThemeContext";

const btnStyle = {cursor:'pointer', borderRadius:'30%', padding:'5px'};

export default () => {
  const {theme} = useContext(ThemeContext);
  
  return (<>
    <div onClick={()=>window.history.back()} style={btnStyle} role="button" tabIndex={0} aria-label="Wstecz" title="Wstecz">
      <FaArrowLeft style={{color: theme === 'dark' ? 'var(--icon-color-dark)' : 'var(--menu-icon-color)'}}/>
    </div>
    <div onClick={()=>window.history.forward()} style={btnStyle} role="button" tabIndex={0} aria-label="Dalej" title="Dalej">
      <FaArrowRight style={{color: theme === 'dark' ? 'var(--icon-color-dark)' : 'var(--menu-icon-color)'}}/>
    </div>
  </>);
};
